import { render, staticRenderFns } from "./MarketingSmsHeader.vue?vue&type=template&id=74127596&scoped=true"
import script from "./MarketingSmsHeader.vue?vue&type=script&lang=js"
export * from "./MarketingSmsHeader.vue?vue&type=script&lang=js"
import style0 from "./MarketingSmsHeader.vue?vue&type=style&index=0&id=74127596&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74127596",
  null
  
)

export default component.exports